import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type { Entity } from '../../types'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.rule.DOC}
  query Rules($tenantId: ID!, $zoneId: ID!, $appId: ID!, $scenarioId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                rules {
                  ...FragmentRateRule
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.RulesQuery,
    Entity[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'rules',
                graphql.transformers.OUT.list(fragments.rule.TRANSFORMER, {
                  onNullish: 'remove',
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.RulesQuery,
  Entity[],
  graphql.schema.RulesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
